<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="6">
        <div class="text-center">
          <img src="img/waf_level.png"
            class="text-center"
            style="margin-left: auto; margin-right: auto;width: auto; height:230px;"
          >
        </div>
      </b-col>
      <b-col sm="6">
        <p :style="`${server.level >= 4 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 4는 정책 레벨 1~4 가 탐지해요.</p>
        <p :style="`${server.level >= 3 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 3는 정책 레벨 1~3 가 탐지해요. </p>
        <p :style="`${server.level >= 2 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 2는 정책 레벨 1~2 가 탐지해요. </p>
        <p :style="`${server.level >= 1 ? 'font-weight:900;color:red;' : 'font-weight:700;' }`"> Level 1는 정책 레벨 1 가 탐지해요. </p>
        <hr>
        <p>
          레벨이 높을수록 더 많은 공격을 탐지해요.<br>
          레벨 설정 후, 상세 정책 설정을 권해요.<br>
        </p>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col class="col-xl-12 col-md-12 align-self-center">
        <p class="title">
          기본 설정
        </p>
        <small>숫자를 클릭하세요.</small>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col class="col-xl-6 col-md-12 align-self-center">
        <b-row>
          <b-col class="col-xl-6 col-md-12 align-self-center text-center" style="cursor: pointer;">
            <strong @click="change">방화벽 정책 :
              <b-badge style="cursor: pointer;" v-if="server.mode == 0" variant="secondary">미사용</b-badge>
              <b-badge style="cursor: pointer;" v-if="server.mode == 1" variant="warning">탐지모드</b-badge>
              <b-badge style="cursor: pointer;" v-if="server.mode == 2" variant="danger">차단모드</b-badge>
            </strong>
            <!-- <b-form-radio-group id="ph_mode" v-model="server.mode" :options="codes.WAF_MODE"> </b-form-radio-group> -->
          </b-col>
          <b-col class="col-xl-6 col-md-12 d-flex align-self-center"></b-col>
          <b-col class="col-xl-6 col-md-12 align-self-center mt-5" style="cursor: pointer;">
            <strong>보안 정책 레벨<br>
              <small class="mt-1">( Level : {{ server.level }})</small>
            </strong>
          </b-col>
          <b-col class="col-xl-6 col-md-12 align-self-center text-center mt-4" style="cursor: pointer;">
            <b-form-radio-group @change="update($event, 'level')" id="ph_level" v-model="server.level" :options="codes.WAF_LEVEL"></b-form-radio-group>
          </b-col>
          <!-- <b-col md="3">
            <div class="pull-right">
              <b-button size="sm" variant="success" @click="rule_confirm = true">Apply</b-button>
              <b-button size="sm" variant="warning" @click="apply_modal = true">Apply to other servers</b-button>
            </div>
          </b-col> -->
        </b-row>
      </b-col>
      <b-col class="col-xl-6 col-md-12 align-self-center">
        <b-card>
          <b-row>
            <b-col class="col-xl-12 col-md-12 align-self-center">
              <p class="title text-center">
                안내
              </p>
              <small class="text-danger">보안 레벨을 높게 설정하면 서비스에 문제가 발생할 수 있어요. 방화벽 레벨이 4 일 경우, 장기 계획을 가지고 설정하는것이 좋아요. </small>
            </b-col>
            <b-col class="col-xl-12 col-md-12 align-self-center text-left mt-5">
              <strong class="mb-3"><b-badge variant="secondary">Off</b-badge> : 현재 선택한 도메인에 대해 WEBCastle 기능이 동작을 하지않아요.</strong>
              <br><br>
              <strong class="mb-3"><b-badge variant="warning">탐지 모드</b-badge> : 탐지만 하고 차단하지 않아요.</strong>
              <br><br>
              <strong class="mb-3"><b-badge variant="danger">차단 모드</b-badge> : 탐지 및 차단 기능이 동작해요.</strong>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
